import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Appointment } from 'src/app/shared/state/appointment/appointment.model';

@Component({
    selector: 'app-appointment-actions-modal',
    templateUrl: './appointment-actions-modal.component.html',
    styleUrls: ['./appointment-actions-modal.component.scss'],
})
export class AppointmentActionsModalComponent implements OnInit {
    cancelAppClicked = false;

    @Input() appointment: Appointment;
    constructor(private modalController: ModalController) {}

    ngOnInit(): void {}

    cancelApp() {
        this.cancelAppClicked = true;
    }

    cancelProcess() {
        this.cancelAppClicked = false;
    }

    cancelAppConfirm() {
        this.closeModal(AppointmentActionsDismissActions.CANCEL);
    }

    closeModal(
        action: AppointmentActionsDismissActions = AppointmentActionsDismissActions.NONE
    ): void {
        this.modalController.dismiss({ action });
    }
}

export enum AppointmentActionsDismissActions {
    NONE,
    CANCEL,
}
